import { createFileRoute } from '@tanstack/react-router'
import LienRightsRequirementsList from '../components/lien-rights-requirements/LienRightsRequirementsList'

export const Route = createFileRoute('/_a/lienRightsRequirements/')({
  component: LienRightsRequirementsList,
})
